<template>
  <div class="wrapper-files">
    <div class="above-table">
      <p>Archivos</p>
    </div>

    <table>
      <thead>
        <tr>
          <th>Tipo archivo</th>
          <th>Seleccionar archivo</th>
          <th>Nombre del archivo</th>
          <th>Cargar archivo nuevo</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Muestrario</td>
          <td>
            <input
              type="file"
              ref="inventoryInput"
              hidden
              @change="onInventoryFileSelected"
              @click="$event.target.value = ''"
            />
            <TableButton
              type="SelectFile"
              @click="$refs.inventoryInput.click()"
            />
          </td>
          <td>{{ inventoryFileName || "No has seleccionado un archivo" }}</td>
          <td>
            <TableButton type="UploadFile" @click="inventoryFileTransaction" />
          </td>
        </tr>

        <tr>
          <td>Seguimiento</td>
          <td>
            <input
              type="file"
              ref="sampleInput"
              hidden
              @change="onSampleFileSelected"
              @click="$event.target.value = ''"
            />
            <TableButton type="SelectFile" @click="$refs.sampleInput.click()" />
          </td>
          <td>{{ sampleFileName || "No has seleccionado un archivo" }}</td>
          <td>
            <TableButton type="UploadFile" @click="sampleFileTransaction" />
          </td>
        </tr>

        <tr>
          <td>Cartera</td>
          <td>
            <input
              type="file"
              ref="invoiceInput"
              hidden
              @change="onInvoiceFileSelected"
              @click="$event.target.value = ''"
            />
            <TableButton
              type="SelectFile"
              @click="$refs.invoiceInput.click()"
            />
          </td>
          <td>{{ invoiceFileName || "No has seleccionado un archivo" }}</td>
          <td>
            <TableButton type="UploadFile" @click="invoiceFileTransaction" />
          </td>
        </tr>

        <tr>
          <td>Pedidos</td>
          <td>
            <input
              type="file"
              ref="orderInput"
              hidden
              @change="onOrderFileSelected"
              @click="$event.target.value = ''"
            />
            <TableButton type="SelectFile" @click="$refs.orderInput.click()" />
          </td>
          <td>{{ orderFileName || "No has seleccionado un archivo" }}</td>
          <td>
            <TableButton type="UploadFile" @click="orderFileTransaction" />
          </td>
        </tr>

        <tr>
          <td>Directorio de clientes</td>
          <td>
            <input
              type="file"
              ref="clientInput"
              hidden
              @change="onClientFileSelected"
              @click="$event.target.value = ''"
            />
            <TableButton type="SelectFile" @click="$refs.clientInput.click()" />
          </td>
          <td>{{ clientFileName || "No has seleccionado un archivo" }}</td>
          <td>
            <TableButton type="UploadFile" @click="clientFileTransaction" />
          </td>
        </tr>

        <tr>
          <td>Reporte de ventas</td>
          <td>
            <input
              type="file"
              ref="reportInput"
              hidden
              @change="onReportFileSelected"
              @click="$event.target.value = ''"
            />
            <TableButton type="SelectFile" @click="$refs.reportInput.click()" />
          </td>
          <td>{{ reportFileName || "No has seleccionado un archivo" }}</td>
          <td>
            <TableButton type="UploadFile" @click="reportFileTransaction" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject, ref } from "vue";
import TableButton from "@/components/commons/controls/TableButton.vue";
import { spinnerProcessKey, successProcessKey } from "@/main";
import { filesUse } from "../files/use/filesUse";

export default defineComponent({
  name: "FilesView",
  components: { TableButton },

  setup() {
    const successProcess = inject(successProcessKey)!;
    const { showSuccessModal } = successProcess;

    const spinnerProcess = inject(spinnerProcessKey)!;
    const { offSpinnerState, onSpinnerState } = spinnerProcess;

    const {
      sampleFileSelected,
      inventoryFileSelected,
      invoiceFileSelected,
      orderFileSelected,
      clientFileSelected,
      reportFileSelected,
      sampleFileName,
      inventoryFileName,
      invoiceFileName,
      orderFileName,
      clientFileName,
      reportFileName,
      onSampleFileSelected,
      onInventoryFileSelected,
      onInvoiceFileSelected,
      onOrderFileSelected,
      onClientFileSelected,
      onReportFileSelected,
      sampleFileOperation,
      inventoryFileOperation,
      invoiceFileOperation,
      clientFileOperation,
      orderFileOperation,
      reportFileOperation,
    } = filesUse();

    async function sampleFileTransaction() {
      if (!sampleFileSelected.value) return;

      try {
        await onSpinnerState();
        await sampleFileOperation(sampleFileSelected.value);
        await offSpinnerState();
        showSuccessModal("Archivo de seguimiento cargado correctamente");
      } catch (error) {
        await offSpinnerState();
        throw error;
      }
    }

    async function inventoryFileTransaction() {
      if (!inventoryFileSelected.value) return;

      try {
        await onSpinnerState();
        await inventoryFileOperation(inventoryFileSelected.value);
        await offSpinnerState();
        showSuccessModal("Archivo de muestrario cargado correctamente");
      } catch (error) {
        await offSpinnerState();
        throw error;
      }
    }

    async function invoiceFileTransaction() {
      if (!invoiceFileSelected.value) return;

      try {
        await onSpinnerState();
        await invoiceFileOperation(invoiceFileSelected.value);
        await offSpinnerState();
        showSuccessModal("Archivo de cartera cargado correctamente");
      } catch (error) {
        await offSpinnerState();
        throw error;
      }
    }

    async function orderFileTransaction() {
      if (!orderFileSelected.value) return;

      try {
        await onSpinnerState();
        await orderFileOperation(orderFileSelected.value);
        await offSpinnerState();
        showSuccessModal("Archivo de pedidos cargado correctamente");
      } catch (error) {
        await offSpinnerState();
        throw error;
      }
    }

    async function clientFileTransaction() {
      if (!clientFileSelected.value) return;

      try {
        await onSpinnerState();
        await clientFileOperation(clientFileSelected.value);
        await offSpinnerState();
        showSuccessModal(
          "Archivo de directorio clientes cargado correctamente"
        );
      } catch (error) {
        await offSpinnerState();
        throw error;
      }
    }

    async function reportFileTransaction() {
      if (!reportFileSelected.value) return;

      try {
        await onSpinnerState();
        await reportFileOperation(reportFileSelected.value);
        await offSpinnerState();
        showSuccessModal("Archivo de reporte de ventas cargado correctamente");
      } catch (error) {
        await offSpinnerState();
        throw error;
      }
    }

    return {
      sampleFileSelected,
      inventoryFileSelected,
      invoiceFileSelected,
      orderFileSelected,
      clientFileSelected,
      reportFileSelected,
      sampleFileName,
      inventoryFileName,
      invoiceFileName,
      orderFileName,
      clientFileName,
      reportFileName,
      onSampleFileSelected,
      onInventoryFileSelected,
      onInvoiceFileSelected,
      onOrderFileSelected,
      onClientFileSelected,
      onReportFileSelected,
      sampleFileTransaction,
      inventoryFileTransaction,
      invoiceFileTransaction,
      orderFileTransaction,
      clientFileTransaction,
      reportFileTransaction,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/files/styles/filesStyle";
</style>
